import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-ethereum', 'CurrencyEthereum', [["path",{"d":"M6 12l6 -9l6 9l-6 9l-6 -9"}],["path",{"d":"M6 12l6 -3l6 3l-6 2l-6 -2"}]]);